import React from 'react';
import Icon from '../../../components/AppIcon';

const PersonaCard = ({ persona, isSelected, onSelect }) => {
  return (
    <div
      className={`relative p-4 md:p-6 rounded-lg border-2 transition-all duration-250 cursor-pointer ${
        isSelected
          ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50 hover:shadow-elevation-md'
      }`}
      onClick={onSelect}
      role="radio"
      aria-checked={isSelected}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          e?.preventDefault();
          onSelect();
        }
      }}
    >
      <div className="flex items-start gap-3 md:gap-4">
        <div
          className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${
            isSelected ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
          }`}
        >
          <Icon name={persona?.icon} size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-base md:text-lg mb-1">{persona?.title}</h3>
          <p className="text-sm text-muted-foreground line-clamp-2">{persona?.description}</p>
        </div>
        <div
          className={`flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${
            isSelected ? 'border-primary bg-primary' : 'border-border bg-background'
          }`}
        >
          {isSelected && <Icon name="Check" size={14} color="#FFFFFF" />}
        </div>
      </div>
    </div>
  );
};

export default PersonaCard;